export default {
      id: "economy-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#economy",
      toString: function () {
        return this.url;
      }
    }